enum EngagementType {
  COMPLEMENTARY = 'COMPLEMENTARY',
  EXCLUSIVE = 'EXCLUSIVE',
}

export default EngagementType;
